<template>
  <div class="vx-row mb-6">
    <div class="vx-col sm:w-1/5 w-full">
      <span>Message</span>
    </div>

    <div class="vx-col sm:w-4/5 w-full">
      <vs-textarea placeholder="Text message" v-model="message" />
      <div
        @click="addPlaceholder(ph.id)"
        class="cursor-pointer"
        v-for="(ph, idx) in placeholders"
        :key="idx"
      >
        <vs-chip>
          {{ ph.name }}
        </vs-chip>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";

export default {
  components: {},
  props: ["action", "automationId"],
  data() {
    return {
      message: "",
    };
  },
  methods: {
    addPlaceholder(placeholder) {
      this.message += "{{" + placeholder + "}}";
    },
    render() {
      return {
        message: this.message,
      };
    },
  },
  computed: {
    ...mapGetters({
      triggerTypes: "automations/triggerTypes",
    }),
    placeholders() {
      return this.$store.getters["handlebars/getFor"]("venue", "guest", "booking").map(
        (e) => {
          return {
            id: e.handlebar,
            name: e.name,
            label: e.handlebar,
          };
        }
      );
    },
  },
  async mounted() {
    if (this.action) {
      this.message = this.action.message;
    }
  },
};
</script>

<style lang="scss">
.custom-chip {
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 5px;
  margin-right: 5px;
  line-height: 30px;
  white-space: normal;
  padding-bottom: 5px;
  border-radius: 15px;
  font-size: 0.8rem;
  background: #f0f0f0;

  color: rgba(0, 0, 0, 0.7);
}
</style>